import { useRecordContext } from 'react-admin';
import { DeliveryMethodEnum } from '../../../../utils/enum';
import type { IData } from '../../../../types';

export const DeliveryMethodFormatter = (props: IData) => {
    const record = useRecordContext(props);
    if (!record.delivery_method) {
        return 'Unknown';
    } else {
        return DeliveryMethodEnum.find((x: IData) => x.id === String(record.delivery_method))?.name;
    }
};

DeliveryMethodFormatter.defaultProps = { label: 'Delivery method' };
